import { sub } from "date-fns";

export const lg_reset_password = {
    lg_reset_password_th: {
        title: "รีเซ็ตรหัสผ่าน",
        subtitle1: "โปรดกรอกรหัสผ่านใหม่ของคุณด้านล่าง",
        new_password: "รหัสผ่านใหม่",
        confirm_password: "ยืนยันรหัสผ่าน",
        put_required_password: "ใส่รหัสผ่าน",
        put_required_new_password: "จะต้องประกอบด้วยอักขระอย่างน้อย 8 ตัว รวมถึงตัวเลขหนึ่งตัว อักษรตัวพิมพ์ใหญ่หนึ่งตัว และอักขระพิเศษ 1 ตัว",
        put_required_confirm_password: "รหัสผ่านไม่ตรงกัน",
        reset_title:"รีเซ็ตรหัสผ่านเสร็จสิ้น!",
        reset_subtitle1:"รหัสผ่านของท่านได้รับการอัปเดตเรียบร้อยแล้ว ท่านสามารถเข้าสู่ระบบได้แล้ว",
        reset_btn:"กลับสู่หน้าลงชื่อเข้าใช้",
    },
    lg_reset_password_en: {
        title: "Reset Password",
        subtitle1:"Please enter your new password below.",
        new_password: "New Password",
        confirm_password: "Confirm Password",
        put_required_password: "Password is required",
        put_required_new_password: "Must include at least 8 characters, one number, one uppercase letter and one special character.",
        put_required_confirm_password: "Password not matched",
        reset_title:"Reset password successfully!",
        reset_subtitle1:"Your password has been updated. You can now log in.",
         reset_btn:"Return to Login",
       
    },
  };
